/* El visor de la galería de la ficha (el `zoom-dialog` de Horizon), UNA FOTO
 * POR PANTALLA con flechas a los lados (Fran, 24/09/2026, con una captura de la
 * competencia: «mira cómo se tendría que ver»).
 *
 * Horizon apila en escritorio todas las fotos a 100 vw de ancho, una debajo
 * de otra, con miniaturas a la derecha: el bote salía ampliado y cortado. La
 * hoja (sección 59 de natnatura-brand.css) pone la lista en fila horizontal,
 * cada foto entera (`contain`) a todo el alto, y esconde las miniaturas; este
 * script añade las dos flechas y ← / → en el teclado, y pide la foto en alta,
 * que Horizon solo cargaba al desplazar el diálogo en vertical.
 *
 * Por delegación en `document`: theme dev sustituye la sección al recargar y
 * se llevaría los oyentes puestos en el nodo. Las flechas se meten en cada
 * diálogo la primera vez que se abre. */
(function () {
  var T = window.NN_TEXTOS || {};
  var FLECHA = '<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true" focusable="false"><path d="M5 12h14M13 6l6 6-6 6" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function lista(dialog) {
    return dialog.querySelector('.dialog-zoomed-gallery');
  }

  function actual(ul) {
    return Math.round(ul.scrollLeft / Math.max(ul.clientWidth, 1));
  }

  function ir(dialog, paso) {
    var ul = lista(dialog);
    if (!ul) return;
    var n = ul.children.length;
    if (n < 2) return;
    var i = (actual(ul) + paso + n) % n;
    ul.scrollTo({ left: i * ul.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    var zoom = dialog.closest('zoom-dialog');
    if (zoom && typeof zoom.loadHighResolutionImage === 'function') zoom.loadHighResolutionImage(ul.children[i]);
  }

  function prepara(dialog) {
    if (dialog.querySelector('.nn-zoom__flecha')) return;
    var ul = lista(dialog);
    if (!ul || ul.children.length < 2) return;
    [['anterior', -1], ['siguiente', 1]].forEach(function (d) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'button button-unstyled nn-zoom__flecha nn-zoom__flecha--' + d[0];
      b.setAttribute('data-nn-zoom-paso', d[1]);
      b.setAttribute('aria-label', T['zoom_' + d[0]] || '');
      b.innerHTML = FLECHA;
      dialog.appendChild(b);
    });
  }

  function alAbrir() {
    document.querySelectorAll('zoom-dialog dialog[open]').forEach(function (dialog) {
      prepara(dialog);
      var ul = lista(dialog);
      var zoom = dialog.closest('zoom-dialog');
      if (ul && zoom && typeof zoom.loadHighResolutionImage === 'function') zoom.loadHighResolutionImage(ul.children[actual(ul)]);
    });
  }

  // se abre al pulsar una foto de la galería: se mira en el fotograma siguiente
  document.addEventListener('click', function (e) {
    var flecha = e.target.closest && e.target.closest('[data-nn-zoom-paso]');
    if (flecha) {
      e.preventDefault();
      e.stopPropagation();
      ir(flecha.closest('dialog'), Number(flecha.getAttribute('data-nn-zoom-paso')));
      return;
    }
    requestAnimationFrame(function () { requestAnimationFrame(alAbrir); });
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
    var dialog = document.querySelector('zoom-dialog dialog[open]');
    if (!dialog) return;
    e.preventDefault();
    ir(dialog, e.key === 'ArrowLeft' ? -1 : 1);
  });

  // si cambia el ancho con el visor abierto, que no se quede entre dos fotos
  window.addEventListener('resize', function () {
    document.querySelectorAll('zoom-dialog dialog[open] .dialog-zoomed-gallery').forEach(function (ul) {
      ul.scrollTo({ left: actual(ul) * ul.clientWidth, behavior: 'instant' });
    });
  });

  // De la segunda foto del pase en adelante van `lazy` (22/10/2026, snippet
  // product-media-gallery-content) para no quitarle ancho de banda a la
  // primera, que es la que mide el LCP. Con la pagina ya cargada se piden
  // igual, en reposo: al pasar de foto o pulsar una miniatura ya estan.
  function precargaPase() {
    document.querySelectorAll('media-gallery slideshow-slide img.product-media__image[loading="lazy"]').forEach(function (img) {
      img.loading = 'eager';
    });
  }
  function enReposo() {
    (window.requestIdleCallback || function (f) { setTimeout(f, 200); })(precargaPase, { timeout: 3000 });
  }
  if (document.readyState === 'complete') enReposo();
  else window.addEventListener('load', enReposo, { once: true });
})();
